import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

const CHAPTERS = [
  { n: "01", label: "A Journey" },
  { n: "02", label: "A Relationship" },
  { n: "03", label: "A Family" },
  { n: "04", label: "A Graduation" },
  { n: "05", label: "A Business" },
  { n: "06", label: "A Comeback" },
  { n: "07", label: "A Loved One" },
  { n: "08", label: "A Milestone" },
  { n: "09", label: "A Dream That Finally Became Real" },
];

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="relative z-10 border-y border-white/5 py-24 md:py-36 overflow-hidden bg-[#080808]"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_50%_50%,rgba(130,73,55,0.22),transparent_70%)]" aria-hidden />

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        {/* Brand declaration */}
        <div className="grid md:grid-cols-12 gap-10 mb-24 md:mb-32">
          <div className="md:col-span-6">
            <Sparkles className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
            <h2 className="font-serif-display text-[32px] sm:text-5xl lg:text-6xl leading-[1.05] mt-5 tracking-tight">
              You give us<br />the story.<br />
              <span className="italic text-[#D4AF37]">We crown the moment.</span>
            </h2>
          </div>
          <div className="md:col-span-6 space-y-5 text-[#F7F1E7]/70 font-light leading-relaxed text-base md:text-lg self-end">
            <p>Crowned Canvas Creations doesn&apos;t simply put a photograph on canvas.</p>
            <p>We learn what the photograph means. We learn the story. We learn the vision.</p>
            <p>Then we transform that story into custom artwork built around the person, moment or meaning behind it.</p>
          </div>
        </div>

        {/* Storytelling chapters */}
        <div className="mb-14 max-w-4xl">
          <p className="overline">Core Belief</p>
          <h2 className="font-serif-display text-[36px] sm:text-5xl lg:text-[84px] leading-[0.98] mt-5 tracking-tight">
            Everybody has<br />
            something <span className="italic text-[#D4AF37]">worth framing.</span>
          </h2>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 mb-16">
          {CHAPTERS.map((c) => (
            <li
              key={c.n}
              data-testid={`chapter-${c.n}`}
              className="group flex items-baseline gap-6 md:gap-10 py-5 md:py-6 hover:bg-[#824937]/10 transition-colors px-2"
            >
              <span className="font-serif-display text-lg md:text-xl text-[#D4AF37] w-10 md:w-14 flex-shrink-0">{c.n}</span>
              <span className="font-serif-display text-2xl md:text-4xl lg:text-5xl text-[#F7F1E7] group-hover:text-[#D4AF37] transition-colors">
                {c.label}.
              </span>
            </li>
          ))}
        </ul>

        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <p className="text-lg md:text-2xl font-light text-[#F7F1E7]/75 leading-snug font-serif-display">
              Those moments deserve more than another place in your phone.
              <span className="text-[#D4AF37] italic"> They deserve to be seen.</span>
            </p>
          </div>
          <div className="md:col-span-5 md:text-right">
            <Link
              to="/#experiences"
              data-testid="manifesto-cta"
              className="group inline-flex items-center gap-3 bg-[#D4AF37] text-[#080808] px-7 py-4 text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#e6c245] transition-all"
            >
              Discover Your Crowned Experience
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
